import OrganizationDetailMembers from '@/screens/OrganizationDetailMembers';

export default function PrivateTabsOrganizationMainMembersRoute() {
  return <OrganizationDetailMembers />;
}
